/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordStockFieldComponent } from '../../admin/form/form-record/fields/stock/form-record-stock-field.component';
/* eslint-enable */

export class FormRecordStockFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordStockFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
